if (document.getElementById("errors")) {
    document.getElementById("errors").scrollIntoView();
}
